import { gql } from '@apollo/client'

export const GetProjectBulkAddStatus = gql`
    query GetProjectBulkAddStatus($input: GetBackendProcessStatusInput!) {
        getProjectBulkAddStatus(input: $input) {
            state
            errorMessage
            progressPercentage
            result {
                addedElements {
                    projectElementNodes {
                        id
                        elementId
                        baseElementId
                        nodeOrder
                        isInProject
                        isDeactivated
                        elementType
                        text
                        treePath
                        parentNodeId
                        projectId
                        isHidden
                        parentTreePath
                        isSearchResult
                        hasChildren
                        isLastSubAssembly
                        isBestPractice
                        isBpPublished
                        isGlobalBestPractice
                        hasBestPractice
                        isImportedToProject
                        importedToProjectId
                        isBasedFromImportedNode
                        isProjectOnly
                        isSpecTextNode
                        isBasedFromManufacturerOption
                        iteration {
                            id
                            name
                        }
                        isMasterSpecClone
                    }
                }
            }
        }
    }
`

export const GetBPApplicationStatus = gql`
    query GetBPApplicationStatus($input: GetBackendProcessStatusInput!) {
        getBestPracticeApplicationStatus(input: $input) {
            state
            errorMessage
            progressPercentage
        }
    }
`
